import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Route, RouterProvider, createBrowserRouter, createRoutesFromElements, Navigate } from 'react-router-dom';
import { Home } from './Pages/Home';
import { NewConsent } from './Pages/Consent/NewConsent';
import { ManageConsent } from './Pages/Consent/ManageConsent';
import { EditConsent } from './Pages/Consent/EditConsent';
import { ConsentDetails } from './Pages/Consent/ConsentDetails';
import { Mis } from './Pages/Mis';
import { UserMis } from './Pages/UserMix';
import { AuthProvider } from './contexts/auth';
import ProtectedRoute from './Components/ProtectedRoute';
import UnProtectedRoute from './Components/UnProtectedRoute';
import MisLogin from './Pages/MisLogin';
import HomePage from './Pages/HomePage';
import { MisAuthProvider } from './contexts/misAuth';
import { MisProtectedRoute } from './contexts/misAuth';
import { ConsentLogin } from './Pages/ConsentLogin';
import { ConsentCallback } from './Pages/ConsentCallback';
import { ManageProfile } from './Pages/ManageProfile';
import {FAQ} from './Pages/FAQ';

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path='/' element={
      <AuthProvider>
        <MisAuthProvider>
          <App />
        </MisAuthProvider>
      </AuthProvider>
    }>
      {/* Homepage with two boxes */}
      <Route index element={<HomePage />} />
      
      {/* Redirect /mis to /mis-user-login */}

      
      {/* Redirect /consent to /consent-login */}
      <Route path="/consent" element={<Navigate to="/consent-login" replace />} />
      
      {/* Consent routes */}
      <Route path='/consent-login' element={<UnProtectedRoute><ConsentLogin /></UnProtectedRoute>} />
      <Route path='/consent-callback' element={<ConsentCallback />} />
      <Route path='/home' element={<ProtectedRoute><Home /></ProtectedRoute>} />
      <Route path='/new-consent' element={<ProtectedRoute><NewConsent /></ProtectedRoute>} />
      <Route path='/manage-consent' element={<ProtectedRoute><ManageConsent /></ProtectedRoute>} />
      <Route path='/edit-consent' element={<ProtectedRoute><EditConsent /></ProtectedRoute>} />
      <Route path='/consent-details/:id' element={<ProtectedRoute><ConsentDetails /></ProtectedRoute>} />
      <Route path='/faq' element={<ProtectedRoute><FAQ /></ProtectedRoute>} />
      <Route path='/manage-profile' element={<ProtectedRoute><ManageProfile /></ProtectedRoute>} />
      
      {/* MIS routes */}
      <Route path='/mis-user-login' element={<MisLogin />} />
      <Route path='/mis-user' element={<MisProtectedRoute><UserMis /></MisProtectedRoute>} />

      {/* user have to login in consent Page first to access the mis page for IBDIC User */}
      <Route path='/ibdic-mis' element={<ProtectedRoute><Mis /></ProtectedRoute>} />
    </Route>
  )
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);

reportWebVitals();